/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { UtilService } from '../services/util.service';
import { AutomateFilter, AutomateTask, AutomateJob } from '../global/models';

@Injectable()
export class AutomateJobService {

  constructor(private http: HttpClient,
    private utilService: UtilService) { }

  getJobs(type: string) {
    return this.http
      .get(
        `/api/v1/automate_job/type/${type}`
      );
  }

  getJob(_id: string) {
    return this.http
      .get(
        `/api/v1/automate_job/${_id}`
      );
  }

  adminGetJobById(_id: string) {
    return this.http
    .get(
      `/api/v1/automate_job/job/${_id}`
    );
  }

  saveJob(job: any): Observable<any> {
    // any time a job is saved, make sure the task enabled state is set to the same as the job enabled state. This doesn't make the task
    // valid (that's a different flag), so there shouldn't be any downstream issues
    job.tasks.forEach(task => {
      task.enabled = job.enabled;
    });
    return this.http
      .post(
        `/api/v1/automate_job`,
        job
      );
  }

  /**
   * Initialize filters with defaults -
   *
   * language: 'en' (all filters should be set to English only as a starting point)
   */
  initFilters() {
    let filters: AutomateFilter[] = [];
    /*
    JOE - 3-26-18 this was moved into the "pink component" design. (email-filter-group)
    because each pink box should be responsible for knowing what filters it can support
    and making sure that those filters exists for any jobs. This way we don't have to
    do any backfill for adding new filters.
    */

    // filters.push({ type: 'email_type', include: [], exclude: [] });
    // filters.push({ type: 'source', include: [], exclude: [] });
    // filters.push({ type: 'language', include: ['all'], exclude: [] });
    // filters.push({ type: 'body', include: [], exclude: [] });
    // filters.push({ type: 'subject', include: [], exclude: [] });
    return filters;
  }

  /**
   * Initialize a task with defaults for adding to a job
   * @param type
   * @param partner
   */
  initTask(type: string) {
    let now = new Date();
    let task: AutomateTask = {
      taskId: this.utilService.randString(24),
      type: type,
      enabled: true,
      deleted: false,
      valid: false,
      invalid_reason: null,
      paused: false,
      paused_reason: null,
      required: true,
      settings: {},
      created_at: now,
      updated_at: now
    };

    return task;
  }
}



// WEBPACK FOOTER //
// ./client/app/services/automate-job.service.ts